import { persistReducer } from 'redux-persist';

import designer from './designer';
import { changeLocale } from './i18n';
import colorPicker from './colorpicker';
import { currentPattern } from './currentPattern';
import query from './query';
import categories from './categories';
import patterns from './patterns';
import { initialState, availableLanguages, priceScales, priceActions } from './initialState';
import favorites from './favorites';
import breakpoint from './breakpoint';
import { categoriestrail } from './navigation';
import icons from '../icons/symbol-defs.svg';
import fabricUpdate, { fabrics } from './fabrics';
import sewpatUpdate, { sewpats } from './sewpats';
import productUpdate, { products } from './products';
import cartUpdate from './cart';
import snackbar from './ui.snackbar';
import recolor from './ui.recoloring';
import siteSearch from './ui.sitesearch';
import elements from './ui.elements';
import patternGallery from './ui.patterngallery';
import pagination from './ui.pagination';
import queryCache from './queryCache';
import prices from './prices';
import persist from './persist';
import header from './ui.header';
import userdata from './userdata';

export const appSettings = (state = {
    store: { rehydrated: false },
    prices: priceScales,
    priceActions,
}, action) => ({
    store: persist(state.store, action),
    prices: prices(state.prices, action),
    priceActions,
});

function appData(state = initialState, action) {
    return {
        i18n: {
            currentLanguage: changeLocale(state.i18n.currentLanguage, action,
        availableLanguages),
            fabrics: fabrics(state.i18n.fabrics, action, availableLanguages),
            sewpats: sewpats(state.i18n.sewpats, action, availableLanguages),
            products: products(state.i18n.products, action, availableLanguages),
        },
        cart: cartUpdate(state.cart, action),
        fabric: fabricUpdate(state.fabric, action),
        sewpat: sewpatUpdate(state.sewpat, action),
        product: productUpdate(state.product, action),
        entities: {
            categories: categories(state.entities.categories, action),
            patterns: patterns(state.entities.patterns, state.currentQuery,
        state.ui.recoloring.activeColorSwatch, action),
            designer: designer(state.entities.designer, action),
        },
        currentQuery: query(state.currentQuery, state.i18n.currentLanguage.code,
      action),
        colorpicker: colorPicker(state.colorpicker, action),
        selectedPattern: currentPattern(state.selectedPattern, action),
        ui: {
            recoloring: recolor(state.ui.recoloring, action),
            breakpoint: breakpoint(state.ui.breakpoint, action),
            siteSearch: siteSearch(state.ui.siteSearch, action),
            snackbar: snackbar(state.ui.snackbar, action),
            elements: elements(state.ui.elements, action),
            patternGallery: patternGallery(state.ui.patternGallery, action),
            pagination: pagination(state.ui.pagination, action,
        state.ui.patternGallery.patternPerPage),
            header: header(state.ui.header, action),
        },
        navigation: {
            categoriestrail: categoriestrail(state.navigation.categoriestrail, action,
        state),
        },
        queryCache: queryCache(state.queryCache, action),
        favorites: favorites(state.favorites, action),
        userdata: userdata(state.userdata, action),
    };
}

export const iconData = (state = { icons }) => state;

export default appData;



// WEBPACK FOOTER //
// ./src/reducers/reducers.js